import styled from 'styled-components'

const ToolboxUi = styled.div`
  padding: 20px;
`

export default ToolboxUi
